import { create } from 'zustand';

const getInitialShow = () =>
  !(typeof window !== 'undefined' && window.innerWidth < 768);

type SideMenuStore = {
  show: boolean;
  open: () => void;
  hide: () => void;
  toggle: () => void;
};

const useSideMenuStore = create<SideMenuStore>(set => ({
  show: getInitialShow(),
  open: () => set({ show: true }),
  hide: () => set({ show: false }),
  toggle: () => set(s => ({ show: !s.show })),
}));

export default useSideMenuStore;
